export default {
  HetContractAmount: 'MysterySoundAmount',
}
